export default __webpack_public_path__ + "static/soc-2-audit-7d1a1d53eff61db5dde3502e122423df.png";